<template>
  <div>
    <v-slide-y-reverse-transition mode="out-in">
      <!-- Show a message when there is no group or a spinner while loading -->
      <v-messages v-if="!categories.length || (!categories.length && loadingCategories)" />
      <!-- Show the panels of products grouped by breadcrumb -->
      <div>
        <v-categories />
        <v-load-more />
      </div>
    </v-slide-y-reverse-transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("classifier");

import VCategories from "./Categories";
import VLoadMore from "./LoadMore";
import VMessages from "../Messages";

export default {
  components: {
    VCategories,
    VLoadMore,
    VMessages
  },
  computed: {
    ...mapState(["categories"])
  },
  created() {
    if (!this.categories.length) {
      this.getCategories();
    }
  },
  methods: {
    ...mapActions(["getCategories"])
  }
};
</script>